export function formatDate(date: Date) {
  const offsetString = date
    .toLocaleString('id-ID', {
      timeZoneName: 'shortOffset',
      hourCycle: 'h23'
    })
    .match(/GMT([+-]\d{2}:\d{2})/)

  const wibOffset = -420 // UTC+7 -> -7 hours * 60 minutes = -420 minutes
  const witaOffset = -480 // UTC+8 -> -8 hours * 60 minutes = -480 minutes
  const witOffset = -540 // UTC+9 -> -9 hours * 60 minutes = -540 minutes

  const localOffset = date.getTimezoneOffset()

  return `${date.getDate()} ${date.toLocaleString('id-ID', { month: 'short' })} ${date.getFullYear()} | ${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')} (${
    localOffset === wibOffset
      ? 'WIB'
      : localOffset === witaOffset
        ? 'WITA'
        : localOffset === witOffset
          ? 'WIT'
          : offsetString && offsetString[1]
            ? offsetString[1]
            : (() => {
                const offsetMinutes = date.getTimezoneOffset()
                const sign = offsetMinutes > 0 ? '-' : '+'
                const absOffsetMinutes = Math.abs(offsetMinutes)
                const hours = Math.floor(absOffsetMinutes / 60)
                return `UTC${sign}${hours}`
              })()
  })`
}

export const epochToDate = (
  epoch: number | string,
  opts?: {
    unit?: 's' | 'ms'; // detik/milidetik
    mode?: 'date' | 'time' | 'datetime';
    month?: 'short' | 'long';
    includeSeconds?: boolean;
  }
): Date | string => {
  const n = typeof epoch === 'string' ? Number(epoch.trim()) : epoch
  if (!Number.isFinite(n)) throw new Error('epoch tidak valid')

  const unit = opts?.unit ?? (n < 1e12 ? 's' : 'ms')
  const date = new Date(unit === 's' ? n * 1000 : n)

  if (!opts?.mode) return date

  switch (opts.mode) {
    case 'date':
      return date.toLocaleDateString('id-ID', {
        day: 'numeric',
        month: opts.month ?? 'short',
        year: 'numeric'
      })
    case 'time':
      return date.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
        second: opts.includeSeconds ? '2-digit' : undefined,
        hourCycle: 'h23'
      })
    case 'datetime':
      return formatDate(date)
    default:
      return date
  }
}
